<template>
  <div
    class="file-thumb"
    :class="{'file-thumb--preview': preview}"
    :style="{'width': width + 'px', 'height': height + 'px'}" >
    <md-icon
      class="md-size-2x file-type-icon"
      :style="{color: colorByFileType(fileName)}" >
      {{ getIconByFileType(fileName) }}
    </md-icon>

    <a href="#"
       v-if="showDeleteBtn"
       class="file-thumb-del-btn absolute"
       @click.prevent="$emit('onDelete')">
      <md-icon>close</md-icon>
    </a>
    <md-tooltip md-direction="top" v-if="preview">
      <div class="ellipsis">{{ fileName }}</div>
    </md-tooltip>
  </div>
</template>

<script>
  import { getIconByFileType, colorByFileType } from '@/utils'
  export default {
    name: "FileThumbnail",
    props: {
      fileName: {
        type: String,
        required: true,
      },
      width: {
        type: Number,
        default: 75,
      },
      height: {
        type: Number,
        default: 75,
      },
      preview: {
        type: Boolean,
        default: false,
      },
      showDeleteBtn: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      getIconByFileType,
      colorByFileType,
    }
  }
</script>

<style lang="scss" scoped>
  .file-type-icon {
    opacity: 0.9;
    &:hover {
      opacity: 1;
    }
  }

  .file-thumb {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    overflow: hidden;
    position: relative;
    display: flex;
    &:hover {
      box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }
    &--preview {
      border: 2px dashed #4caf50;
    }
    &-del-btn {
      top: 0;
      right: 0;
      background-color: #00000080;
      .md-icon {
        color: #ffffff !important;
        font-size: 15px !important;
      }
    }
  }
</style>
